module.exports = __webpack_public_path__ + "img/low-fat-mac-and-cheese.7a04296f.jpg";